export const getEnumKeys = (enumType: Enum): string[] => {
    const values = Object.values(enumType);
    const isAllString = values.every((value) => typeof value === "string");
    if (isAllString) {
        return Object.keys(enumType);
    }
    const enumValuesCount = Object.values(enumType).length / 2;
    return Object.keys(enumType).slice(enumValuesCount);
};

interface Enum {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}
